export const errorMessage = {
  required: 'Campo obrigatório.',
  cpfFormat: 'Tem algo errado com o formato desse número. Tente de novo.',
  emailFormat: 'Esse e-mail não está no formato certo. Tente de novo.'
}
